import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Activity } from '../models/activity.model';
import { FeedbackDto, UpsertFeedbackDto } from '../models/feedback.model';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private apiUrl = environment.apiUrl + '/Feedback';

  http = inject(HttpClient);

  saveFeedback(feedback: UpsertFeedbackDto): Observable<Activity> {
    if (feedback.id) {
      return this.http.put<Activity>(`${this.apiUrl}/${feedback.id}`, feedback);
    } else {
      return this.http.post<Activity>(this.apiUrl, feedback);
    }
  }

  getFeedbackById(id: number): Observable<FeedbackDto> {
    return this.http.get<FeedbackDto>(`${this.apiUrl}/${id}`);
  }

  getActivityByFeedbackId(id: number): Observable<Activity> {
    return this.http.get<Activity>(`${this.apiUrl}/${id}`);
  }

  getQuestions(): Observable<FeedbackDto> {
    return this.http.get<FeedbackDto>(`${this.apiUrl}/questions`);
  }
}
